import React from 'react';
import { Link } from 'react-router-dom';
import { formatUTCDate } from '../../utils/utils';
import UserDetailLink from '../common/UserDetailLink';

/**
 * CEO Requests list table (feature 066-ceo-requests).
 *
 * Uses the shared `au-` table system (au-table-wrap / au-table / au-link) so this screen is
 * visually indistinguishable from the other portal lists. Bootstrap's `table-striped` and
 * `btn-*` classes are NOT used anywhere in this portal.
 *
 * TWO THINGS THIS COMPONENT EXISTS TO GET RIGHT:
 *
 * 1. Every value here is an OPTIONAL string the mobile app may simply have omitted — the portal
 *    does not own the write path, so it cannot assume any field is present. A missing value gets
 *    an explicit placeholder, never an empty cell, because a blank cell reads as a rendering
 *    fault rather than as missing data.
 *
 * 2. The preview is rendered as TEXT. React escapes by default, and that default IS the security
 *    control: the message is untrusted member input, so dangerouslySetInnerHTML must never
 *    appear in this file (FR-018).
 */

const MISSING = <span className="cr-unavailable">—</span>;

export default function CeoRequestsTable({ items }) {
  return (
    <div className="au-table-wrap">
      <table className="au-table cr-requests-table">
        <thead>
          <tr>
            <th>From</th>
            <th>Email</th>
            <th>Submitted</th>
            <th>Message</th>
            <th aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {(items || []).map((it) => (
            <tr key={it.id}>
              <td>
                <UserDetailLink userId={it.user_id} fallback={<span className="cr-unavailable">Not provided</span>}>
                  {it.user_name}
                </UserDetailLink>
              </td>
              <td><UserDetailLink userId={it.user_id} fallback={MISSING} testId="user-detail-email-link">{it.user_email}</UserDetailLink></td>
              <td className="cr-submitted">
                {formatUTCDate(it.created_display) || <span className="cr-unavailable">Unknown</span>}
              </td>
              <td>
                {it.preview
                  ? <span className="cr-preview" title={it.preview}>{it.preview}</span>
                  : <span className="cr-unavailable">No message</span>}
              </td>
              <td className="cr-actions-cell">
                <Link className="au-link cr-read" to={`/ceo-requests/${it.id}`}>
                  Read request
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
